// PLAN CONSTANTS

export const PLAN_FREE = 'free';
export const PLAN_MONTHLY = 'dcp-monthly-2';
export const PLAN_YEARLY = 'dcp-yearly-2';

export const PLAN_FREE_PRICE = 0;
export const PLAN_MONTHLY_PRICE = 900;
export const PLAN_YEARLY_PRICE = 9000;

export const STRIPE_KEY = process.env.NODE_ENV === 'production' ? 'pk_live_12O63ikUdsD9i9bjVyJu8s8R' : 'pk_test_9iYu6apayWoVE2GYtgg3wrez'



// WEBPACK FOOTER //
// ./src/constants.js